import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-redemptions-site-traffic',
    templateUrl: './redemptions-site-traffic.component.html'
})
export class RedemptionSiteTrafficComponent implements OnInit {

    constructor(private title: Title, private router: Router) {
        this.title.setTitle('Dashboard - Site Traffic Statistics | XYZ Corp. Verification Workspace');
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

    }

    ///////////////////////////////////////// SHARED OPTIONS ///////////////////////////////////////////////////
    public legendTrue: boolean = true;
    public legendFalse: boolean = false;
    public chartTypeDoughnut: string = 'doughnut';
    public chartTypeLine: string = 'line';

    // Number of Sessions (last 24 hours)
    public numberOfSessionsHoursOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                id: 'y-axis-0',
                scaleLabel: {
                    display: true,
                    labelString: 'No. of Sessions',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: false
                }
            }],
            xAxes: [{
                id: 'x-axis-0',
                scaleLabel: {
                    display: true,
                    labelString: 'Hour',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                gridLines: {
                    display: false
                }
            }]
        },
        legend: {
            position: 'top',
            labels: {
                usePointStyle: true
            }
        }
    };

    public numberOfSessionsHoursLabels: Array<any> = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '23', '24'];
    public numberOfSessionsHoursData: Array<any> = [
        { data: [5, 6, 7, 5, 2, 21, 56, 42, 8, 5, 5, 12, 13, 16, 17, 15, 2, 21, 56, 42, 8, 5, 5, 3, 3], label: 'Returning Visitors' },
        { data: [13, 15, 14, 17, 18, 34, 109, 89, 27, 21, 32, 46, 42, 55, 54, 57, 68, 34, 109, 89, 27, 21, 16, 16, 12], label: 'New Visitors' }

    ];

    // Number of Sessions (last 8 Days)
    public numberOfSessionsDaysOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                id: 'y-axis-0',
                scaleLabel: {
                    display: true,
                    labelString: 'No. of Sessions',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: false
                }
            }],
            xAxes: [{
                id: 'x-axis-0',
                scaleLabel: {
                    display: true,
                    labelString: 'Hour',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                gridLines: {
                    display: false
                }
            }]
        },
        legend: {
            position: 'top',
            labels: {
                usePointStyle: true
            }
        }
    };
    public numberOfSessionsDaysLabels: Array<any> = ['10 May', '11 May', '12 May', '13 May', '14 May', '15 May', '16 May', '17 May'];
    public numberOfSessionsDaysData: Array<any> = [
        { data: [5, 6, 7, 5, 2, 21, 56, 42], label: 'Opened' }

    ];

    // Total Sessions
    public totalSessionsOptions: any = {
        backgroundColor: 'red',
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true
            }
        },
        cutoutPercentage: 80,
        elements: {
            arc: {
                borderWidth: 5 // border line
            }
        }
    };
    public totalSessionsLabels: string[] = ['Smartphone', 'Tablet', 'Desktop'];
    public totalSessionsData: number[] = [3410, 2665, 1754];

    //////////////////////////////////////////// COLOURS ///////////////////////////////////////////////////////
    public solidBackgroundColors = [
        {
            backgroundColor: ['rgba(67,91,115,1)', 'rgba(193,189,170,1)', 'rgba(224,216,174,1)', 'rgba(115,91,93,1)', 'rgba(112,114,112,1)', 'rgba(163,170,163,1)', 'rgba(128,109,141,1)', 'rgba(112,92,126,1)', 'rgba(146,114,166,1)']
        }
    ];

    public lineChartColors = [
        {
            backgroundColor: 'rgba(104,132,155,0.1)',
            borderColor: 'rgba(104,132,155,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(104,132,155,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(104,132,155,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(224,216,174,0.1)',
            borderColor: 'rgba(224 ,216,174,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(224,216,174,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(224,216,174,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        }
    ];

    // events
    public chartClicked(e: any): void {
        //console.log(e);
    }
    public chartHovered(e: any): void {
        //console.log(e);
    }

}
